import React from 'react'

export class Case extends React.Component {
  render() {
    const { children, auth } = this.props;
    return typeof(children)==='function' ? children(auth) : children;
  }
}

Case.displayName = 'Case'

export class NoAuth extends React.Component {
  render() {
    const { children } = this.props;
    return typeof(children)==='function' ? children() : children;
  }
}

NoAuth.displayName = 'NoAuth'

export class Else extends React.Component {
  render() {
    const { children, auth } = this.props;
    return typeof(children)==='function' ? children(auth) : children;
  }
}

Else.displayName = 'Else'

export default class AuthWrapper extends React.Component {
  state = { auth: null }

  constructor(props) {
    super(props);
    if (typeof(window)==='undefined') return;

    window._authed.then(data => {
      this.setState({ auth: data })
    })
  }

  render() {
    const { children } = this.props;
    const { auth } = this.state;

    const descendants = React.Children.toArray(children);

    if (!auth || !auth.username) {
      // if a NoAuth child exists, use it
      for (let child of descendants.filter(d => d.type.displayName==="NoAuth")) {
        return React.cloneElement(child, {...child.props, auth});
      }
      // otherwise render nothing
      return <span/>;
    }

    // render first matching Case
    for (let child of descendants.filter(d => d.type.displayName==="Case")) {
      if (child.props.test(auth)) {
        return React.cloneElement(child, {...child.props, auth});
      }
    }
    // otherwise, find an Else
    for (let child of descendants.filter(d => d.type.displayName==="Else")) {
      return React.cloneElement(child, {...child.props, auth});
    }

    // otherwise render nothing
    return <span/>;
  }
}
